import React, { Component } from 'react';
import { Field } from 'redux-form';
import { intlShape, injectIntl } from 'react-intl';
import TextField from '../../TextField/TextField';
import { isEmpty } from '../../FormElement/FormElementUtils';
import PropTypes from 'prop-types';


export class Street1 extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        localePrefix: PropTypes.string.isRequired,
        idPrefix: PropTypes.string,
        ariadescribedby: PropTypes.string
    };

    render() {
        const { intl, localePrefix, idPrefix, ariadescribedby } = this.props;

        return (
            <div>
                <Field
                    id={idPrefix ? `${idPrefix}-street1` : 'street1'}
                    name="street1"
                    autoComplete="disabled"
                    required={true}
                    component={TextField}
                    ariadescribedby={ariadescribedby}
                    label={intl.formatMessage({id: `${localePrefix}.addressLine1`})}
                    validate={[
                        isEmpty(intl.formatMessage({id: `${localePrefix}.ADDRESSLINE1_IS_NULL`}))
                    ]}
                />
            </div>
        );
    }
}

export default injectIntl(Street1);
